function sliderNavigation(slider) {
  const arrowLeft = document.querySelector('.section-review-slider .arrow-left');
  const arrowRight = document.querySelector('.section-review-slider .arrow-right');

  function init() {
    arrowLeft.addEventListener('click', () => slider.prev());
    arrowRight.addEventListener('click', () => slider.next());
  }

  slider.on('created', () => {
    init();
  });
}
var slider = new KeenSlider(
  '#review-slider',
  {
    initial: 0,
    mode: 'snap',
    slides: {
      perView: 'auto',
    },
  },
  [sliderNavigation]
);